The partial position profile to search application questions.

This should include the same field values that will eventually be used to create or post the `PositionProfile`.
